<!-- eslint-disable vue/attributes-order -->
<script>
import GoogleOAuthButton from 'dashboard/components/ui/Auth/GoogleOAuthButton.vue';
import GoogleCalendarItem from './GoogleCalendarItem.vue';
import { googleService } from '../services/google-service';
import Spinner from 'shared/components/Spinner.vue';
import { useAlert } from 'dashboard/composables';
import { emitter } from 'shared/helpers/mitt';

export default {
  components: {
    GoogleOAuthButton,
    GoogleCalendarItem,
    Spinner,
  },

  data() {
    return {
      isLoading: false,
      accountHasAuthentication: false,
      showConfirmationPopup: false,
      showConfirmationDeleteAllPopup: false,
      showCallbackErrorConfirmation: false,
      callBackErrorMessages: [
        'Parece que você não permitiu que o MultiAtendedor acesse o escopo "CALENDÁRIO" da sua conta Google. Por favor, clique no botão de login novamente e forneça essa permissão',
        'Parece que houve um problema na sua autenticação Google. Para corrigir esse problema você deve acessar sua conta Google e revogar os acessos do MultiAtendedor (link: https://myaccount.google.com/u/0/connections?hl=pt_br), após isso, retorne aqui no nosso painel e se autentique novamente',
        'Parece que houver um problema na sua autenticação Google. Por favor, atualize a página e tente novamente',
      ],
      callbackErrorMsg: '',
      currentGoogleEmail: '',
      fetchedCalendars: [],
      privacyPolicyLink: 'https://multiatendedor.com.br/privacy/',
    };
  },
  mounted() {
    this.checkCallbackErrors();
  },
  methods: {
    showDeletePopUp(type) {
      if (type === 'auth') this.showConfirmationPopup = true;
      if (type === 'all_schedules') this.showConfirmationDeleteAllPopup = true;
    },
    closeDeletePopup() {
      this.showConfirmationPopup = false;
      this.showConfirmationDeleteAllPopup = false;
    },
    closeCallbackPopup() {
      this.showCallbackErrorConfirmation = false;
    },
    closeCallbackPopup1() {
      this.showCallbackErrorConfirmation = false;
    },
    // eslint-disable-next-line consistent-return
    async checkCallbackErrors() {
      let callbackUrlParams;
      try {
        this.checkAccountAuthentication();
        // Backend sends URL params as base64
        callbackUrlParams = atob(Object.keys(this.$route.query).toString());
        // If account has a saved authentication it means URL was changed
        if (callbackUrlParams && this.accountHasAuthentication)
          throw new Error();

        const paramInclude = string => callbackUrlParams.includes(string);
        const callbackError = number => {
          this.callbackErrorMsg = this.callBackErrorMessages[number];
          this.showCallbackErrorConfirmation = true;
        };
        // To component complete its data render
        setTimeout(() => {
          if (paramInclude('missing_calendar_scope=true')) callbackError(0);
          else if (paramInclude('missing_refresh_token=')) callbackError(1);
          else if (paramInclude('bad_credentials=true')) callbackError(2);
        }, 50);
      } catch (e) {
        return this.redirectToSafeUrl();
      }
    },
    redirectToSafeUrl() {
      this.$router.replace({ query: null });
    },

    showAlert(message) {
      emitter.emit('newToastMessage', message);
    },

    // Requistions
    async checkAccountAuthentication() {
      try {
        const googleEmail = await googleService.getEmail();
        this.accountHasAuthentication = !!googleEmail;
        if (googleEmail) {
          this.currentGoogleEmail = googleEmail;
          await this.getSchedules();
        }
      } catch (error) {
        this.accountHasAuthentication = false;
      }
    },
    async confirmDeleteRequest() {
      try {
        const response = await googleService.deleteAuth();
        if (response.status === 200) {
          this.showConfirmationPopup = false;
          this.accountHasAuthentication = false;
          useAlert('✅  -  Vínculo removido com sucesso');
        }
      } catch (error) {
        this.showConfirmationPopup = false;
        useAlert(
          '❌  - Ocorreu um problema ao excluir seu vínculo com o Google. Por favor, tente novamente mais tarde'
        );
      }
    },
    async getSchedules() {
      try {
        const calendars = await googleService.getSchedules();
        if (calendars)
          this.fetchedCalendars = calendars.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
      } catch (error) {
        useAlert(
          '❌  - Não foi possível buscar suas agendas. Por favor, tente novamente mais tarde'
        );
      }
    },
    async syncSchedules() {
      try {
        this.isLoading = true;
        const response = await googleService.syncSchedules();
        if (response.status === 200) {
          await this.getSchedules();
          useAlert(
            this.$t(
              'INTEGRATION_APPS.GOOGLE_CALENDAR.REQUISTIONS_RESPONSE_ALERTS.CALENDARS_UPDATED.SUCCESS'
            )
          );
          this.isLoading = false;
        } else throw new Error();
      } catch (error) {
        useAlert(
          this.$t(
            'INTEGRATION_APPS.GOOGLE_CALENDAR.REQUISTIONS_RESPONSE_ALERTS.CALENDARS_UPDATED.ERROR'
          )
        );
        this.isLoading = false;
      }
    },
    async deleteAllSchedules() {
      this.isLoading = true;
      try {
        const response = await googleService.deleteAllSchedules();
        if (response.status === 200) {
          this.showConfirmationDeleteAllPopup = false;
          await this.getSchedules();
          useAlert(
            this.$t(
              'INTEGRATION_APPS.GOOGLE_CALENDAR.REQUISTIONS_RESPONSE_ALERTS.DELETE_ALL_CALENDARS.SUCCESS'
            )
          );
          this.isLoading = false;
        } else throw new Error();
      } catch (error) {
        this.showConfirmationDeleteAllPopup = false;
        useAlert(
          this.$t(
            'INTEGRATION_APPS.GOOGLE_CALENDAR.REQUISTIONS_RESPONSE_ALERTS.DELETE_ALL_CALENDARS.ERROR'
          )
        );
        this.isLoading = false;
      }
    },
  },
};
</script>

<template>
  <div>
    <h4
      class="block-title my-0 mx-2 text-2xl text-slate-800 dark:text-slate-100"
    >
      {{ $t('INTEGRATION_APPS.GOOGLE_CALENDAR.TITLE') }}
    </h4>
    <div class="login_and_remove">
      <div>
        <GoogleOAuthButton
          v-if="!accountHasAuthentication"
          gcalendar-auth
          :show-separator="false"
        >
          {{ $t('REGISTER.OAUTH.GOOGLE_SIGNUP') }}
        </GoogleOAuthButton>
        <button
          v-if="accountHasAuthentication"
          class="button expanded button__disconnect_google"
          @click="showDeletePopUp('auth')"
        >
          {{ $t('INTEGRATION_APPS.GOOGLE_CALENDAR.DISCONNECT.TEXT') }}
        </button>
      </div>
      <input
        v-if="accountHasAuthentication"
        class="margin_top_bottom custom-input"
        type="text"
        :value="`${$t(
          'INTEGRATION_APPS.GOOGLE_CALENDAR.INPUT_TEXT'
        )}: ${currentGoogleEmail}`"
        readonly
      />
      <p class="mt-[5px] ml-[5px] mb-0 mr-0">
        {{ $t('INTEGRATION_APPS.GOOGLE_CALENDAR.POLICY_LINK.DESCRIPTION') }}
        <a
          class="sender--available-name"
          :href="privacyPolicyLink"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          {{
            $t('INTEGRATION_APPS.GOOGLE_CALENDAR.POLICY_LINK.HYPERLINK_LABEL')
          }}
        </a>
      </p>
      <hr class="operator__line" />
    </div>

    <!-- MAIN CONTENT - SHOW/EDIT/REMOVE EACH CALENDAR -->
    <main v-if="accountHasAuthentication">
      <Spinner v-if="isLoading" color-scheme="dark" />
      <button class="button" @click="syncSchedules()">
        {{ $t('INTEGRATION_APPS.GOOGLE_CALENDAR.UPDATE_CALENDARS') }}
      </button>
      <woot-button
        v-if="fetchedCalendars.length > 0"
        v-tooltip.top="
          $t('INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.DELETE_ALL.LABEL')
        "
        variant="smooth"
        color-scheme="alert"
        icon="delete"
        @click="showDeletePopUp('all_schedules')"
      />
      <div class="margin_top_bottom">
        <h5 class="my-0 mx-2 text-slate-800 dark:text-slate-100">
          {{ $t('INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.TITLE') }}
        </h5>
        <div v-if="fetchedCalendars.length > 0">
          <GoogleCalendarItem
            v-for="calendar in fetchedCalendars"
            :key="calendar.id"
            :calendar="calendar"
            @get-schedules="getSchedules"
          />
        </div>
        <p v-else>
          {{ $t('INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.NO_CALENDARS') }}
        </p>
      </div>

      <woot-delete-modal
        v-model:show="showConfirmationPopup"
        :on-close="closeDeletePopup"
        :on-confirm="confirmDeleteRequest"
        title="DESCONECTAR GOOGLE DO MULTIATENDEDOR"
        :message="$t('INTEGRATION_APPS.GOOGLE_CALENDAR.DISCONNECT.WARNING')"
        :message-value="
          $t('INTEGRATION_APPS.GOOGLE_CALENDAR.DISCONNECT.CONFIRM_DELETE')
        "
        :confirm-text="$t('INTEGRATION_APPS.GOOGLE_CALENDAR.DISCONNECT.YES')"
        :reject-text="$t('INTEGRATION_APPS.GOOGLE_CALENDAR.DISCONNECT.NO')"
      />
      <woot-delete-modal
        v-model:show="showConfirmationDeleteAllPopup"
        :on-close="closeDeletePopup"
        :on-confirm="deleteAllSchedules"
        :title="
          $t('INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.DELETE_ALL.LABEL')
        "
        :message="
          $t('INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.DELETE_ALL.WARNING')
        "
        :message-value="
          $t(
            'INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.DELETE_ALL.CONFIRM_DELETE'
          )
        "
        :confirm-text="
          $t('INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.DELETE_ALL.YES')
        "
        :reject-text="
          $t('INTEGRATION_APPS.GOOGLE_CALENDAR.CALENDARS.DELETE_ALL.NO')
        "
      />
    </main>
    <woot-delete-modal
      v-model:show="showCallbackErrorConfirmation"
      :on-close="closeCallbackPopup"
      :on-confirm="closeCallbackPopup1"
      title="ERRO NA AUTENTICAÇÃO"
      :message="callbackErrorMsg"
      message-value=""
      confirm-text="OK"
      reject-text="Cancelar"
    />
  </div>
</template>

<style lang="scss" scoped>
.custom-input {
  font-size: calc(min(1.1rem + 1.25vw, 16px));
  margin: 8px 0;
}
.login_and_remove {
  position: relative;

  div {
    display: flex;
    align-items: center;
    gap: var(--space-one);

    .button__disconnect_google {
      background: var(--r-600);
      border: 1px solid var(--s-100);
      color: var(--white);
      max-width: 200px;
    }
  }

  .operator__line {
    width: 100%;
    border-bottom: 1px solid var(--color-border);
  }

  input {
    min-width: fit-content;
    width: 80vw;
    max-width: 600px;
  }
}
.margin_top_bottom {
  margin: 15px 0;
}

.action-button {
  height: 40px;
}
</style>
